export default "__VITE_ASSET__b00d1e47__"